{
  "validation": {
    "required": "This field is required",
    "email": "Please enter a valid email address",
    "minLength": "Must be at least {{min}} characters",
    "maxLength": "Must be at most {{max}} characters",
    "passwordMatch": "Passwords do not match"
  },
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "page": "Page {{current}} of {{total}}",
    "showing": "Showing {{from}} to {{to}} of {{total}} results"
  },
  "table": {
    "noResults": "No results found",
    "loading": "Loading data...",
    "sortAsc": "Sort ascending",
    "sortDesc": "Sort descending"
  }
}
